import { PricingPlanPeriod } from "../../../shared/types/pricingPlanTypes";

export type PricingPlanType = "lite" | "start" | "standard" | "premium";

export interface PricingPlan {
  type: PricingPlanType;
  periodOfTime: PricingPlanPeriod;
  benefits: string[];
  disadvantages?: string[];
  numberOfNotifications: number;
  price: number; // Fallback price CZK (hardcoded)
  huPrice: number; // Fallback price HUF (hardcoded)
  skPrice: number; // Fallback price EUR (hardcoded)
  plPrice: number; // Fallback price PLN (hardcoded)
  priceId?: string;
  apiPrice?: number; // Actual price from Stripe API (in cents)
  apiCurrency?: string; // Currency code from API (e.g., "czk", "eur", "huf", "pln")
}

export const yearPricingPlans: PricingPlan[] = [
  {
    type: "lite",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
    ],
    disadvantages: ["unlimitedWebsites", "logoCancel", "customBranding"],
    numberOfNotifications: 6000,
    price: 39,
    huPrice: 610,
    skPrice: 1.59,
    plPrice: 6.92,
  },
  {
    type: "start",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
    ],
    disadvantages: ["logoCancel", "customBranding"],
    numberOfNotifications: 30000,
    price: 247,
    huPrice: 3867,
    skPrice: 10.09,
    plPrice: 43.71,
  },
  {
    type: "standard",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
      "logoCancel",
      "customBranding",
    ],
    numberOfNotifications: 70000,
    price: 457,
    huPrice: 7154,
    skPrice: 18.58,
    plPrice: 80.5,
  },
  {
    type: "premium",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
      "logoCancel",
      "customBranding",
    ],
    numberOfNotifications: 150000,
    price: 833,
    huPrice: 13040,
    skPrice: 33.86,
    plPrice: 146.72,
  },
];

export const monthPricingPlans: PricingPlan[] = [
  {
    type: "lite",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
    ],
    disadvantages: ["unlimitedWebsites", "logoCancel", "customBranding"],
    numberOfNotifications: 6000,
    price: 47,
    huPrice: 736,
    skPrice: 1.91,
    plPrice: 8.29,
  },
  {
    type: "start",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
    ],
    disadvantages: ["logoCancel", "customBranding"],
    numberOfNotifications: 30000,
    price: 297,
    huPrice: 4650,
    skPrice: 12.07,
    plPrice: 52.45,
  },
  {
    type: "standard",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
      "logoCancel",
      "customBranding",
    ],
    numberOfNotifications: 70000,
    price: 547,
    huPrice: 8563,
    skPrice: 22.23,
    plPrice: 96.61,
  },
  {
    type: "premium",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "unlimitedWebsites",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "zboziAndHeureka",
      "logoCancel",
      "customBranding",
    ],
    numberOfNotifications: 150000,
    price: 997,
    huPrice: 15607,
    skPrice: 40.51,
    plPrice: 176.07,
  },
];
